// Handle section visibility
export const initializeObserver = () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('section').forEach(section => {
    observer.observe(section);
  });
};

// Handle touch events
let touchStartY = 0;
let touchEndY = 0;

export const handleTouchStart = (e) => {
  touchStartY = e.touches[0].clientY;
};

export const handleTouchEnd = (e) => {
  touchEndY = e.changedTouches[0].clientY;
  handleSwipe();
};

const handleSwipe = () => {
  const diff = touchStartY - touchEndY;
  const currentSection = document.elementFromPoint(window.innerWidth / 2, window.innerHeight / 2).closest('section');
  
  if (Math.abs(diff) > 50) { // Minimum swipe distance
    if (diff > 0 && currentSection.nextElementSibling) {
      currentSection.nextElementSibling.scrollIntoView({ behavior: 'smooth' });
    } else if (diff < 0 && currentSection.previousElementSibling) {
      currentSection.previousElementSibling.scrollIntoView({ behavior: 'smooth' });
    }
  }
}; 